import {store} from '/app/src/store';
import {getSocket} from '/app/src/store/socket'
import { toast } from 'react-toastify';

import {NetworkSelector} from '/app/src/model/selectors'

export default class Model {
    constructor() {
        this.handleResponse = this.handleResponse.bind(this);
        this.toast = toast
        this.url = this._getUrl.bind(this);
        this.token = this._getToken.bind(this);
        this.socket = this._getSocket.bind(this);
        this.state = this._getState.bind(this);
        this.networkSelector = NetworkSelector;
        this.network = NetworkSelector;
    }

    handleResponse(dispatch){
        return (err, res) => {
            if(res.statusCode === 200){
                this._success(dispatch, err, res);
            }else{
                this._failure(dispatch, err, res);
            }
        }
    }

    _getUrl(){
        return store.getState().getIn(['system', 'api']);
    }
    _getToken(){
        return store.getState().getIn(['user', 'login', 'token']);
    }
    _getSocket(){
        return getSocket();
    }
    _getState(){
        return store.getState();
    }

}

/*
example of function with dispatcher and selector:
getCategoriesRequest(){
    const selectorFunction = (state) => {
        return {
            'categories': FAQSelector.getCategories(state),
            'network': NetworkSelector.get(state, 'CATEGORIES_GET'),
        }
    }

    const dispatchFunction = ()=> {
        const url = this.url()
        const token = this.token()

        return (dispatch) => {
            dispatch({type: 'CATEGORIES_GET_REQUEST'});
            return request
                .post(`${url}/v2/api/faq/categories/get`)
                .send({})
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch({
                            type: 'CATEGORIES_GET_SUCCESS',
                            payload: res.body.categories
                        })
                    }else{
                        dispatch({type: 'CATEGORIES_GET_ERROR', error: err});

                    }
                });
        }
    }
    return { selector: selectorFunction, dispatcher: dispatchFunction }
}

*/



// WEBPACK FOOTER //
// ./src/model/model.js